<template>
  <div class="component">
    <h1>{{ scopedStrings.title }}</h1>
    <p class="mem-header">
      <span class="value">{{ scopedStrings.address }}</span>
      <span class="value">{{ scopedStrings.value }}</span>
    </p>
    <div class="mem-words">
      <div class="stack-pointers">
        <div class="ebp" v-bind:style="{top : ebpYPosition + 'px'}">
          <i class="fa fa-caret-left"></i> EBP
        </div>
        <div class="esp" v-bind:style="{top : espYPosition + 'px'}">
          <i class="fa fa-caret-left"></i> ESP
        </div>
      </div>
      <div class="word" v-for="word in words" v-bind:key="word.id">
        <div class="label">{{ word.address }}</div>
        <div class="value " v-if="isNull(word.value)">
          {{ word.value }}
        </div>
        <div class="value modified" v-else>{{ word.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Memory",
    props: {
      scopedStrings: {
        type: Object,
        required: true
      },
      initialValue: {
        required: true
      }
    },
    data () {
      return {
        words : this.initialValue.words,
        nullWord : this.initialValue.nullWord,
        esp : this.initialValue.esp,
        ebp : this.initialValue.ebp,
        indexModified : 0,
        memoryWordHeight : 0  // the height in pixels of a memory word, padding and margin included
      }
    },
    computed: {
      ebpYPosition () {
        // The register's value divided by 4 gives the number of words to skip before placing the pointer.
        return this.ebp / 4 * this.memoryWordHeight;
      },
      espYPosition () {
        return this.esp / 4 * this.memoryWordHeight;
      }
    },
    created () {
      window.addEventListener("resize", this.updateMemoryWordHeight);
    },
    destroyed () {
      window.removeEventListener("resize", this.updateMemoryWordHeight);
    },
    mounted () {
      this.updateMemoryWordHeight();
    },
    methods:{
      update(newValue) {
        this.words = newValue.words;
        this.nullWord = newValue.nullWord;
        this.esp = newValue.esp;
        this.ebp = newValue.ebp;
      },
      isNull(value) { // Check if is a null word
        return value === this.nullWord;

      },
      updateMemoryWordHeight() {
        /*
        childNodes[2] refers to the div containing the memory words
        This div contains the stack-pointers and the memory words, childNodes[1] refers to the first memory word.
        */
        this.memoryWordHeight = this.$el.childNodes[2].childNodes[1].getBoundingClientRect().height;
      }
    }
  }
</script>

<style scoped>
  .component {
    flex: 0 0;
    min-width: 235px;
    width: 235px;
    max-width: 235px;
  }

  .mem-header,
  .word {
    display: flex;
  }

  .mem-header {
    margin: 5px 8px 0 7px;
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
  }

  .mem-words {
    height: 250px;
    margin: 2px 8px 8px 0;
    overflow-y: auto;
  }

  .mem-words .label,
  .mem-words .value {
    font-size: 14px;
  }

  .modified {
    color: var(--Memory-modified-foreground);
  }

  .stack-pointers {
    position: relative;
  }

  .ebp,
  .esp {
    position: absolute;
    top: 0;
    margin-top: 4px;
    width: 45px;
    font-weight: 700;
    transition: top 400ms ease-out;
  }

  .ebp {
    right: 48px;
    color: var(--Memory-ebp-foreground);
  }

  .esp {
    right: 1px;
    color: var(--Memory-esp-foreground);
  }
</style>
